import { PropsWithChildren, useMemo } from "react"
import { ListOptionsContext } from "@bundles/parts/components/ListV2/ContextProvider/ListOptions"
import { useErpInfosContext } from "@bundles/parts/components/ListV2/ContextProvider"
import { useCarouselOptions } from "./useCarouselOptions"

export function CarouselOptionsProvider(props: PropsWithChildren<unknown>) {
    const { isNoTeccomRequestAvailable } = useErpInfosContext()
    const carouselOptions = useCarouselOptions()

    const mergedCarouselOptions = useMemo(() => {
        return { ...carouselOptions, isNoTeccomRequestAvailable }
    }, [carouselOptions, isNoTeccomRequestAvailable])

    return <ListOptionsContext.Provider value={mergedCarouselOptions}>{props.children}</ListOptionsContext.Provider>
}
